export const stackRow = {
  flexDirection: 'row',
}

export const stackColumn = {
  flexDirection: 'column-reverse',
}

export const invertColumn = {
  flexDirection: 'column',
}
